import React, { FC } from 'react'

type IconProps = {
  className?: string
  size?: number
  direction?: 'up' | 'down' | 'left' | 'right'
}

export const DownArrowIcon: FC<IconProps> = ({ className, size, direction = 'down' }) => {
  const getRotation = (dir: IconProps['direction']) => {
    switch (dir) {
      case 'up':
        return 'rotate(180deg)'
      case 'left':
        return 'rotate(90deg)'
      case 'right':
        return 'rotate(270deg)'
      case 'down':
      default:
        return 'rotate(0deg)'
    }
  }

  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      style={{ transform: getRotation(direction) }}
      viewBox={'0 0 20 20'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M9.45328 16.7812L4.20328 11.2812C3.92203 10.9688 3.92203 10.5 4.23453 10.2188C4.54703 9.9375 5.01578 9.9375 5.29703 10.25L9.26578 14.4062V3.75C9.26578 3.34375 9.57828 3 10.0158 3C10.422 3 10.7658 3.34375 10.7658 3.75V14.4062L14.7033 10.25C14.9845 9.9375 15.4845 9.9375 15.7658 10.2188C16.0783 10.5 16.0783 10.9688 15.797 11.2812L10.547 16.7812C10.3908 16.9375 10.2033 17 10.0158 17C9.79703 17 9.60953 16.9375 9.45328 16.7812Z'
        }
        fill={'currentColor'}
      />
    </svg>
  )
}
